"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useSearch = useSearch;
exports.SearchInline = SearchInline;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

function useSearch(props) {
  var _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? "" : _props$defaultValue,
      onChange = props.onChange,
      _props$debounceTime = props.debounceTime,
      debounceTime = _props$debounceTime === void 0 ? 300 : _props$debounceTime,
      _props$closeOnSubmit = props.closeOnSubmit,
      closeOnSubmit = _props$closeOnSubmit === void 0 ? true : _props$closeOnSubmit,
      _props$blurOnSubmit = props.blurOnSubmit,
      blurOnSubmit = _props$blurOnSubmit === void 0 ? true : _props$blurOnSubmit,
      _onSubmit = props.onSubmit;

  var _useState = (0, _react.useState)(defaultValue),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var inputRef = (0, _react.useRef)(null);

  var _useState2 = (0, _react.useState)(false),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var debounceTimeout = (0, _react.useRef)(null);

  var changeValue = function changeValue(val) {
    clearTimeout(debounceTimeout.current);

    if (val === "") {
      // no debounce for empty
      if (onChange) {
        onChange(val);
      }
    } else {
      debounceTimeout.current = setTimeout(function () {
        if (onChange) {
          onChange(val);
        }
      }, debounceTime);
    }

    setOpen(true);
  };

  var inputProps = {
    value: inputValue,
    onChange: function onChange(val) {
      setInputValue(val);
      changeValue(val);
    },
    label: "Search",
    controlRef: inputRef,
    type: "search",
    onFocus: function onFocus() {
      setOpen(true);
    }
  };

  var close = function close() {
    setOpen(false);
  };

  var formProps = {
    as: "form",
    action: "",
    onSubmit: function onSubmit(e) {
      if (closeOnSubmit) {
        close();
      }

      if (blurOnSubmit) {
        inputRef.current.blur();
      }

      e.preventDefault();

      if (_onSubmit) {
        _onSubmit(inputValue);
      }
    }
  };
  var resultsProps = {
    "aria-hidden": true
  };
  var submitButtonProps = {
    type: "submit"
  };

  var clear = function clear() {
    setInputValue("");
  };

  return {
    inputProps: inputProps,
    close: close,
    clear: clear,
    formProps: formProps,
    resultsProps: resultsProps,
    submitButtonProps: submitButtonProps,
    isOpen: isOpen
  };
}

function Search(props) {
  var controller = props.controller;

  if (!controller) {
    controller = useSearch(props);
  }

  var input = props.input,
      layer = props.layer,
      children = props.children,
      _props$hideOnLinkClic = props.hideOnLinkClick,
      hideOnLinkClick = _props$hideOnLinkClic === void 0 ? true : _props$hideOnLinkClic;
  var _controller = controller,
      inputProps = _controller.inputProps,
      close = _controller.close,
      formProps = _controller.formProps,
      isOpen = _controller.isOpen;
  var anchorRef = (0, _react.useRef)(null);
  children = typeof children === "function" ? children({
    close: close
  }) : children;
  layer = _react["default"].cloneElement(layer, {
    isOpen: children && isOpen,
    anchoredTo: anchorRef,
    onClose: function onClose(params) {
      if (params && params.type === "esc") {// esc by default comes from "input type=search".
      } else {
        close();
      }
    },
    children: children
  });
  return __jsx(_Box["default"], {
    onClick: function onClick(e) {
      if (hideOnLinkClick && e.target && e.target.tagName === "A") {
        close();
      }
    }
  }, __jsx(_Box["default"], formProps, _react["default"].cloneElement(input, (0, _objectSpread2["default"])({}, inputProps, {
    _ref: anchorRef
  }))), layer);
} // function SearchDialog(props) {
//     let {
//         input,
//         layer,
//         children,
//         hideOnLinkClick = true
//     } = props;
//
//     const {inputProps, close, formProps, isOpen} = useSearch(props);
//
//     children = typeof children === "function" ? children({close}) : children;
//
//     layer = React.cloneElement(layer, {
//         isOpen: children && isOpen,
//         anchoredTo: inputProps.controlRef,
//         onClose: (params) => {
//             if (params && params.type === "esc") { // esc by default comes from "input type=search".
//
//             } else {
//                 close();
//             }
//         },
//         children
//     });
//
//     return (
//         <Box
//             onClick={e => {
//                 if (hideOnLinkClick && e.target && e.target.tagName === "A") {
//                     close();
//                 }
//             }}
//         >
//             <Box
//                 {...formProps}
//             >
//                 {React.cloneElement(input, inputProps)}
//             </Box>
//             {layer}
//         </Box>
//     );
// }


function SearchInline(props) {
  var input = props.input,
      inputContainer = props.inputContainer,
      searchForm = props.searchForm,
      children = props.children,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? "static" : _props$mode;

  var _useSearch = useSearch((0, _objectSpread2["default"])({}, props, {
    closeOnSubmit: false,
    blurOnSubmit: false
  })),
      inputProps = _useSearch.inputProps,
      submitButtonProps = _useSearch.submitButtonProps,
      resultsProps = _useSearch.resultsProps,
      close = _useSearch.close,
      formProps = _useSearch.formProps,
      isOpen = _useSearch.isOpen; // inline search doesn't have to blur because it's always fullscreen


  children = typeof children === "function" ? children({
    close: close
  }) : children;
  var inputContainerRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(0),
      offset = _useState3[0],
      setOffset = _useState3[1];

  (0, _react.useEffect)(function () {
    if (mode !== "static") {
      setOffset(inputContainerRef.current.getBoundingClientRect().height);
    }
  }, []);
  input = _react["default"].cloneElement(input, inputProps);
  var content;

  if (typeof inputContainer === "function") {
    content = inputContainer({
      input: input
    });
  } else {
    content = __jsx(_Box["default"], {
      sx: inputContainer
    }, input);
  } // searchForm overrides old mechanism


  if (searchForm) {
    content = searchForm({
      inputProps: inputProps,
      submitButtonProps: submitButtonProps
    });
  }

  return __jsx(_Box["default"], {
    sx: {
      position: "relative",
      height: "100%",
      width: "100%",
      minHeight: "inherit",
      maxHeight: "inherit",
      minWidth: "inherit",
      maxWidth: "inherit"
    }
  }, __jsx(_Box["default"], (0, _extends2["default"])({
    sx: {
      position: mode === "absolute" ? "absolute" : mode === "fixed" ? "fixed" : "relative",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 1
    }
  }, formProps, {
    ref: inputContainerRef
  }), content), children && isOpen && __jsx(_Box["default"], {
    sx: {
      position: "relative",
      height: "100%",
      width: "100%",
      minHeight: "inherit",
      maxHeight: "inherit",
      minWidth: "inherit",
      maxWidth: "inherit",
      paddingTop: offset,
      overflowY: "auto"
    }
  }, children));
}
/**8
 * TODO:
 * - tab sequence should go to the dialog and then to the input.
 * - SearchDialog (feature: automatic hiding of dialog when link inside is clicked -> actually this should be a feature of all dialogs).
 */


var _default = Search;
exports["default"] = _default;